export enum ValidationErrorCategory {
  FatalError = 'FatalError',
  UserInput = 'UserInput',
}

export enum ValidationErrorCode {
  // this is the only user error that we have so far
  RequiredFieldNotSpecified = 'REQUIRED_FIELD_NOT_SPECIFIED',
}

export interface ValidationError {
  category: ValidationErrorCategory;
  code: ValidationErrorCode;
  schemaId: string;
  message: string;
  nodeId: string;
  details: Record<string, unknown>;
  collectionId?: string;
}
